import { SVGProps } from 'react'

const ArrowBackward = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="17"
      height="14"
      viewBox="0 0 17 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.524.339.66 5.355A2.37 2.37 0 0 0 0 7c0 .616.237 1.208.66 1.645l4.864 5.016c.213.217.5.339.8.339s.587-.122.8-.34a1.17 1.17 0 0 0 .335-.828 1.2 1.2 0 0 0-.336-.828l-3.73-3.838h12.473c.3 0 .59-.123.802-.341S17 7.309 17 7c0-.31-.12-.606-.332-.825a1.12 1.12 0 0 0-.802-.342H3.392l3.731-3.838a1.18 1.18 0 0 0 .335-.824 1.2 1.2 0 0 0-.33-.826A1.115 1.115 0 0 0 5.524.339"
        fill={props.color ? props.color : '#1A1E3D'}
      />
    </svg>
  )
}

export default ArrowBackward
